import { render, staticRenderFns } from "./verhuizen-checklist.vue?vue&type=template&id=1a3dedc1"
import script from "./verhuizen-checklist.vue?vue&type=script&lang=js"
export * from "./verhuizen-checklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports